import * as React from "react";
import { Path, Rect, G, Defs, ClipPath } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const BDIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="BD" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path fill="#38A17E" d="M0 0h16v12H0z" />
      <Path
        fill="#F72E45"
        fillRule="evenodd"
        d="M6 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
